import { render, staticRenderFns } from "./modal-edit-delete-exercise.vue?vue&type=template&id=76f72003&scoped=true&lang=pug"
import script from "./modal-edit-delete-exercise.js?vue&type=script&lang=js&external"
export * from "./modal-edit-delete-exercise.js?vue&type=script&lang=js&external"
import style0 from "./modal-edit-delete-exercise.vue?vue&type=style&index=0&id=76f72003&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76f72003",
  null
  
)

export default component.exports